import { render, staticRenderFns } from "./OrdersVendor.vue?vue&type=template&id=3fbe4ca6&"
import script from "./OrdersVendor.vue?vue&type=script&lang=js&"
export * from "./OrdersVendor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports